var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "156.000000pt",
    height: "156.000000pt",
    viewBox: "0 0 156.000000 156.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,156.000000) scale(0.050000,-0.050000)",
    fill: "#ffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665 2533 c-142 -78 -152 -292 -19 -374 149 -91 321 6 321 181 0 162 -166 269 -302 193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406 2521 c-174 -106 -88 -401 118 -401 79 0 172 72 193 149 41 147 -57 291 -197 291 -27 0 -79 -18 -114 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2246 2501 c-173 -105 -89 -401 114 -401 121 0 241 148 207 256 -54 170 -184 228 -321 145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446 1801 c-174 -106 -88 -401 118 -401 79 0 172 72 193 149 41 147 -57 291 -197 291 -27 0 -79 -18 -114 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646 1781 c-174 -106 -88 -401 118 -401 79 0 172 72 193 149 41 147 -57 291 -197 291 -27 0 -79 -18 -114 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2206 1761 c-173 -105 -89 -401 114 -401 140 0 238 144 197 291 -22 79 -114 149 -197 149 -27 0 -79 -18 -114 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1487 1111 c-178 -77 -175 -328 5 -403 59 -25 77 -25 136 0 182 76 183 328 1 404 -80 33 -64 33 -142 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705 1093 c-191 -105 -117 -413 99 -413 80 0 172 71 194 150 52 190 -130 354 -293 263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2245 1093 c-142 -78 -152 -292 -19 -374 177 -108 368 47 311 252 -33 120 -183 183 -292 122z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotMenu);
export default __webpack_public_path__ + "static/media/dot-menu.2a64b09cc4b42f3c05f400f2cd9b4782.svg";
export { ForwardRef as ReactComponent };